import { gql } from '@apollo/client';
import { Settings } from '@mui/icons-material';

import { useUserOrgId } from '../../auth/authentication';
import { orgPrefixedName } from '../../utils/formatting';
import { InputState } from '../../utils/inputState';
import { openInNewTab } from '../../utils/links';
import { ReturnComponent } from '../../utils/reactTypes';
import { AxleIconButton } from '../buttons/AxleIconButton';
import { AxleAutocompleteMultiselectWithShortChips } from '../formFields/multiselectFields';

export interface ITerritoryOption {
    id: string;
    name: string;
    organization: {
        id: string;
        name: string;
    };
}

export const TerritoryOptionFragment = gql`
    fragment TerritoryOptionFragment on Territory {
        id
        name
        organization {
            id
            name
        }
    }
`;

export const TerritoriesFieldMoreOptions = ({
    label = 'Territories',
    enabled = true,
    inputState,
    clinicianTerritories,
    allTerritories,
}: {
    label?: string;
    enabled?: boolean;
    inputState: InputState<string[]>;
    clinicianTerritories: ITerritoryOption[];
    allTerritories: ITerritoryOption[];
}): ReturnComponent => {
    const userOrgId = useUserOrgId();
    const showOrgColumn = allTerritories.some(
        (territory) => territory.organization.id !== userOrgId,
    );

    const territoriesNotInClinicianList = allTerritories.filter(
        (territory) => !clinicianTerritories.some((ct) => ct.id === territory.id),
    );

    return (
        <AxleAutocompleteMultiselectWithShortChips
            label={label}
            enabled={enabled}
            inputState={inputState}
            options={clinicianTerritories.length ? clinicianTerritories : allTerritories}
            moreOptions={clinicianTerritories.length ? territoriesNotInClinicianList : []}
            optionToValue={(territory) => territory.id}
            optionToLabel={(territory) => orgPrefixedName(territory, showOrgColumn)}
            trailingButtons={
                <AxleIconButton
                    icon={<Settings />}
                    tooltip={'Manage Territories'}
                    onClick={() => openInNewTab('/territories')}
                />
            }
        />
    );
};
